Identifier of the associated `PositionProfile` when this draft was created from or is editing an existing profile.
Corresponds to `PositionProfile.profileId`.
